import React, { Component } from 'react';
import { HashRouter as Router, Route } from 'react-router-dom';
import './App.css';

import Navbar from '../src/components/Navbar';
import Footer from '../src/components/Footer';

import Index from '../src/components/Index';
import Menu from '../src/components/Menu';
import Services from '../src/components/Services';
import Blog from '../src/components/Blog';
import BlogSingle from '../src/components/BlogSingle';
import About from '../src/components/About';
import Shop from '../src/components/Shop';
import ProductSingle from '../src/components/ProductSingle';
import Cart from '../src/components/Cart';
import Contact from '../src/components/Contact';
import Checkout from '../src/components/Checkout';

class App extends Component {
  render() {
    return (
      <Router basename="/" hashType="noslash">
        <div className="App">
          <Navbar />
          <div>
            <Route exact path="/" component={Index} />
            <Route exact path="/menu" component={Menu} />
            <Route exact path="/services" component={Services} />
            <Route exact path="/blog" component={Blog} />
            <Route exact path="/blog-single" component={BlogSingle} />
            <Route exact path="/about" component={About} />
            <Route exact path="/shop" component={Shop} />
            <Route exact path="/product-single" component={ProductSingle} />
            <Route exact path="/cart" component={Cart} />
            <Route exact path="/contact" component={Contact} />
            <Route exact path="/checkout" component={Checkout} />
          </div>
          <Footer />
        </div>
      </Router>
    );
  }
}

export default App;
